import { useQuery } from '@tanstack/react-query'
import { repositoryFactory, DataSourceStrategy, CacheStrategy } from '@rammetec/data-access'
import { ORGANIZATION_READ, type OrganizationRead } from '@vectorhub/domain'

/** `org.products.vectorhub.allowedModules` — org ceiling written by SysColect. */
export function useOrgVectorhubAllowedModules(orgId: string | null) {
  const { data, isLoading } = useQuery({
    queryKey: ['org-allowed-modules', orgId],
    queryFn: async () => {
      const repo = await repositoryFactory.getRepository<OrganizationRead>(
        'org',
        ORGANIZATION_READ,
        DataSourceStrategy.Firestore,
        CacheStrategy.InMemory,
      )
      const doc = await repo.getById(orgId!)
      return {
        contracted: doc?.products?.vectorhub?.contracted ?? false,
        allowedModules: doc?.products?.vectorhub?.allowedModules ?? [],
        aiContracted: doc?.products?.ai?.contracted === true,
      }
    },
    enabled: !!orgId,
    staleTime: 5 * 60 * 1000,
  })

  return {
    contracted: data?.contracted ?? false,
    allowedModules: data?.allowedModules ?? [],
    /** SysColect `products.ai.contracted` — assistant chrome only; gateway still enforces. */
    aiContracted: data?.aiContracted ?? false,
    isLoading: !!orgId && isLoading,
  }
}
